import React, {useEffect, useState, useRef} from "react";
import css from "./index.module.scss";
import { useInView } from "react-intersection-observer";
import SplitText from "@/components/splitText";
import slideFadeIn from "scripts/animations/slideFadeIn";
import popFadeIn from "scripts/animations/popFadeIn";
import inViewSettings from "scripts/animations/inViewSettings";
import ImageCard from "@/components/imageCard";
import { trimTeaser } from "scripts/utils";

export default function Articles({
  articles = [],
  headline = "All About Landing Pages",
  subheadline = "We've helped hundreds of clients boost conversions with optimized landing pages.",
}) {
  const [elements, setElements] = useState({
    text: useInView(inViewSettings(slideFadeIn)),
    cards: useInView(inViewSettings(popFadeIn)),
  });

  return <section className={`section ${css.articles}`}>
    <div className="sectionInner">
      <div ref={elements.text.ref}>
        <h2>
          <SplitText text={headline} className="target"/>
        </h2>
        <div className={css.subheadline}>
          <SplitText text={subheadline} className="target"/>
        </div>
      </div>
      <div className={css.cards} ref={elements.cards.ref}>
        {(articles || [])
          .sort((a, b) => {
            if (a.attributes.priority === b.attributes.priority){
              return (new Date(b.attributes.publishedAt)).getTime() - (new Date(a.attributes.publishedAt)).getTime();
            }
            return b.attributes.priority - a.attributes.priority;
          })

          .map((article, idx) => <ImageCard
            key={article.id}
            headline={article.attributes.headline}
            href={`/resources/${article.attributes.slug}`}
            image={article?.attributes?.coverArt?.data?.attributes}
            imageSizes="(max-width: 900px) 100vw, 40vw"
            loading="lazy"
            className="target"
          >
            <div className={css.articleTeaser}>{trimTeaser(article.attributes.teaser, idx)}</div>
          </ImageCard>)}
      </div>
    </div>
  </section>;
}

